import { Button, ConfigProvider, Popover, notification } from 'antd';
import { BsStars } from 'react-icons/bs';
import { COOKIE_KEY, cacheOnly, old_design_storage } from '@shared/constants';
import Cookies from 'js-cookie';
import { config } from '@/lib/env-helpers';
import { UiVersionEnum, useSwitchUiVersionMutation, useauthMeQuery } from '@/types/generated/graphql';
import { useStoreMigrateModal } from '@modules/design-switch/channel-migrate.model';
import { useTranslation } from 'react-i18next';

export function DesignSwitchBadge() {
  const { openModal } = useStoreMigrateModal();
  const { data: user } = useauthMeQuery(cacheOnly);
  const isOwner = user?.authMe?.data?.userWorkspaceRole?.[0]?.role?.slug === 'owner';
  const { t } = useTranslation();
  const [switchVersion, { loading }] = useSwitchUiVersionMutation({
    variables: { uiVersion: UiVersionEnum.v1 },
    onCompleted: oldDesignSwitchHandler,
    onError: (err) => {
      notification.error({ message: err?.message });
    },
  });

  function oldDesignSwitchHandler() {
    const deviceId = Cookies.get(COOKIE_KEY.deviceId) ?? '';
    const accessToken = Cookies.get(COOKIE_KEY.accessToken) ?? '';
    const workspaceSecret = Cookies.get(COOKIE_KEY.workspaceSecret) ?? '';
    const refreshToken = Cookies.get(COOKIE_KEY.refreshToken) ?? '';
    const sessionId = Cookies.get(COOKIE_KEY.sessionId) ?? '';

    localStorage.setItem(
      old_design_storage.localStorage.tokens,
      JSON.stringify({
        sessionId,
        access: accessToken,
        refresh: refreshToken,
      })
    );

    localStorage.setItem(old_design_storage.localStorage.wksSecret, workspaceSecret);
    localStorage.setItem(old_design_storage.localStorage.deviceId, deviceId);

    window.location.replace(config.VAROSA_OLD_DESIGN + '/design-switch');
  }

  return (
    <>
      <Popover
        trigger={'click'}
        title={
          <div className="space-y-4">
            <img src="/switch.png" />
            <div className="space-y-1">
              <p className="text-[16px] text-text-700">{t('switch_to_old_experience')}</p>
              <p className="text-sm">{t('go_back_to_the_previous_version_of_the_interface')}</p>
              <div className="mt-2 flex gap-3 justify-center flex-col">
                <Button type="primary" className="!rounded-full" loading={loading} onClick={() => switchVersion()}>
                  {t('switch_to_old_experience')}
                </Button>
                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        colorBorder: 'var(--color-primary-200)',
                        colorText: 'var(--color-primary-400)',
                      },
                    },
                  }}
                >
                  <Button hidden={!isOwner} className="!rounded-full" icon={<BsStars />} onClick={() => openModal()}>
                    {t('use_new_experience_permanently')}
                  </Button>
                </ConfigProvider>
              </div>
            </div>
          </div>
        }
      >
        <Button className="!rounded-full">
          <div className="flex items-center gap-1">
            <img src="/favicon.ico" alt="Calilio Logo" className="size-6" />
            <p className="hidden md:block">{t('switch_to_old_experience')}</p>
          </div>
        </Button>
      </Popover>
    </>
  );
}
